/* eslint-disable */
import memberInfo from 'core/app/data/member-info';
import antiForgeryToken from 'core/app/data/anti-forgery-token';
import BodyContainer from 'core/app/ui/layout/body-container';
import SiteHeader from 'core/app/ui/layout/site-header';
import SiteHeaderProfile from 'core/app/ui/layout/site-header-profile';
import SiteSearch from 'core/app/ui/layout/site-search';
import SideMenuUI from 'core/app/ui/layout/side-menu-ui';
import SideMenuNotificationsUI from 'core/app/ui/layout/side-menu-notifications-ui';
import SiteHeaderNotificationsUI from 'core/app/ui/layout/site-header-notifications-ui';
import Navigation from 'core/app/ui/layout/navigation';
import ToggleElementsUI from 'core/app/ui/toggle-elements';
import NavigationData from 'core/app/data/navigation';
import NavigationFilterData from 'core/app/data/navigation-filter';
import bootScribeAndMetrics from 'core/app/boot/boot-scribe-and-metrics';
import SearchSuggestionService from 'core/app/data/search-suggestion-service';
import SearchSuggestion from 'core/app/ui/search-suggestion';
import SearchTracking from 'core/app/ui/search-tracking';
import MessageBoxUI from 'core/app/ui/message-box-ui';
import NavCategoriesUI from 'core/app/ui/layout/nav-categories-ui';
import CategoriesSectionUI from 'core/app/ui/categories-section-ui';
import GoogleTagManager from 'core/app/ui/layout/google-tagmanager';
import disableZoomIfAndroidChrome from 'core/utils/disable-zoom';
import WindowResize from 'core/utils/window-resize';
import TempData from 'core/app/data/temp-data';
import Loading from 'core/app/ui/loading';
import ModalUI from 'core/app/ui/modal-ui';
import ModalTooltipUI from 'core/app/ui/modal-tooltip-ui';
import NavigationModal from 'core/app/data/navigation-modal';
import Login from 'core/app/ui/layout/login';
import MegaMenuUI from 'core/app/ui/layout/mega-menu-ui';
import FeatureFeedbackLink from 'core/app/ui/feature-feedback/feature-feedback-link';
import SavedSearchMonitorTogglerUI from 'core/app/ui/saved-search-monitor-toggler-ui';
import WindowLoad from 'core/utils/window-load';
import WindowScroll from 'core/utils/window-scroll';
import PreventDefault from 'core/utils/prevent-default';
import HybridAppEvents from 'core/utils/hybrid-app-events';
import isHybridAppWithMinBuild from 'core/utils/is-hybrid-app-with-min-build';
import Nuggad from 'core/app/ui/layout/ads/nuggad';
import GoogleAdsLoader from 'core/app/ui/layout/ads/google-ads-loader';
import GptLogger from 'core/app/ui/layout/ads/gpt-logger';
import BetaSignupService from 'core/app/data/beta-signup-service';
// BetaSignupTriggerUI from // 'core/app/ui/beta-signup/beta-signup-trigger-ui';
// BetaOptoutTriggerUI from // 'core/app/ui/beta-signup/beta-optout-trigger-ui';
import SignupReferralPathCookieCreator from 'core/app/ui/layout/signup-referral-path-cookie-creator';
import TriotFlightBridge from 'core/utils/triot-flight-bridge';
import Blueshift from 'core/utils/blueshift';
import LogBrokenAds from 'core/utils/log-broken-ads';

function enableBlueshift(initData, Blueshift) {
    if (initData.featureSwitches && initData.featureSwitches['blueshift-tracking']) {
        Blueshift.attachTo(document, { initData: initData });
    }
}

module.exports = initData => {
    memberInfo.set(initData);
    antiForgeryToken.set(initData);
    bootScribeAndMetrics(initData);

    if (initData.enablePushState) {
        Navigation.attachTo(document);
    }

    NavigationFilterData.attachTo(document);

    // this service is needed even when pushstate is disabled
    NavigationData.attachTo(document, { enablePushState: initData.enablePushState, version: initData.version });

    SearchSuggestionService.attachTo(document);
    GoogleTagManager.attachTo(document);

    PreventDefault.attachTo(document.body);
    ModalUI.attachTo(document.body);
    ModalTooltipUI.attachTo(document.body);
    BodyContainer.attachTo(document.body, { initData: initData });
    SiteHeaderNotificationsUI.attachTo('[data-site-header-notifications]');
    SiteHeader.attachTo('[data-site-header]', { initData: initData });
    SiteHeaderProfile.attachTo('[data-site-header-profile]');
    SiteSearch.attachTo('[data-search-field]', { initData: initData });
    SearchSuggestion.attachTo('[data-search-suggestion]');
    SideMenuUI.attachTo('[data-side-menu]');
    SideMenuNotificationsUI.attachTo('[data-side-menu]');
    MessageBoxUI.attachTo('.message-box-wrapper');
    NavCategoriesUI.attachTo('.nav-categories');
    ToggleElementsUI.attachTo('[data-search-filter-box]');
    CategoriesSectionUI.attachTo('.view-categories-category');
    disableZoomIfAndroidChrome();
    WindowResize.attachTo(document);

    TempData.attachTo('#temp-data');
    Loading.attachTo(document);
    NavigationModal.attachTo(document);
    Login.attachTo(document);
    SearchTracking.attachTo(document);
    MegaMenuUI.attachTo(document, { initData: initData });
    FeatureFeedbackLink.attachTo(document, { initData: initData });
    BetaSignupService.attachTo(document);
    SavedSearchMonitorTogglerUI.attachTo(document.body);
    WindowLoad.attachTo(document);
    WindowScroll.attachTo(document);

    if (isHybridAppWithMinBuild(1)) {
        HybridAppEvents.attachTo(document);
    }

    // BetaSignupTriggerUI.attachTo('[data-beta-signup]');
    // BetaOptoutTriggerUI.attachTo('[data-beta-opt-out]');
    SignupReferralPathCookieCreator.attachTo('[data-reg-user-link]');
    TriotFlightBridge.attachTo(document);

    // do not enable Nuggad for /selling
    /* jshint ignore:start */
    if (window.location.pathname.indexOf('/selling') < 0) {
        Nuggad.attachTo(document);
    }
    /* jshint ignore:end */

    if (initData.featureSwitches && initData.featureSwitches['google-ads']) {
        if (initData.featureSwitches['ad-metrics']) {
            GptLogger.attachTo(document);
        }

        GoogleAdsLoader.attachTo(document, { initData: initData });
    }

    enableBlueshift(initData, Blueshift);

    if (initData.featureSwitches && initData.featureSwitches['broken-ads-tracking']) {
        LogBrokenAds.attachTo(document);
    };
};





// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/boot/boot-layout.js